import React from 'react'
import Notes from './Notes'

export default function home(props) {
  return (
    <div>
      <Notes showAlert={props.showAlert} />
    </div>
  )
}
